Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SurveysSelectView extends Backbone.View
  template: JST['backbone/templates/monitoring/select/surveys']
  className: 'select-view'

  initialize: ({@surveys}) ->

  render: ->
    @$el.html @template
      surveys: @surveys
    @_initializeChosen()
    @

  _initializeChosen: ->
    @$el.find('select').chosen
      width: '410px'
      placeholder_text: I18n.t('monitoring.dashboard.surveys.select')
      allow_single_deselect: true
      search_contains: true

  selectedSurvey: ->
    selectedOption = @_selectedOption()
    return null unless selectedOption
    selectedSurveyId = parseInt(selectedOption)
    (survey for survey in @surveys when survey.id is selectedSurveyId)[0]

  anySurveySelected: ->
    if @_selectedOption()? then @_enableSelectedSurveyTooltip() else @_disableSelectedSurveyTooltip()
    @_selectedOption()?

  _selectedOption: ->
    selectedOption = @$el.find('select').val()
    if selectedOption? and selectedOption.length then selectedOption else null

  _enableSelectedSurveyTooltip: () ->
    surveyName = @$el.find('.chosen-search-input')[0].nextElementSibling.textContent
    @$el.find('.chosen-container').attr('title', surveyName)

  _disableSelectedSurveyTooltip: () ->
    @$el.find('.chosen-container').attr('title', '')
